export default __webpack_public_path__ + "../staticImages/bg-paper.jpg";